export enum userLockStatus {
  None,
  Locked,
  RequireForceSignOff,
  ConfirmSupervisor,
  Supervisor,
}
